(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("Redux"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "Redux", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["AzSearch"] = factory(require("React"), require("Redux"), require("ReactDOM"));
	else
		root["AzSearch"] = factory(root["React"], root["Redux"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_47__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition